<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="ch00_fm04_copy"></a><a id="page_viii"></a>Copyright © 1999 by Lily King</p>
<p class="textcenter">All rights reserved. No part of this book may be reproduced in<br/>any form or by any electronic or mechanical means, including information storage and<br/>retrieval systems, without permission in writing from the publisher, except by a<br/>reviewer, who may quote brief passages in a review. Scanning, uploading, and<br/>electronic distribution of this book or the facilitation of such without the permission<br/>of the publisher is prohibited. Please purchase only authorized electronic editions, and<br/>do not participate in or encourage electronic piracy of copyrighted materials. Your<br/>support of the author’s rights is appreciated. Any member of educational institutions<br/>wishing to photocopy part or all of the work for classroom use, or anthology, should<br/>send inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003 or<br/><span class="weblink"><a class="nounder" href="http://permissions@groveatlantic.com" target="_blank">permissions@groveatlantic.com</a></span></p>
<p class="textcenter"><em>Published simultaneously in Canada<br/>Printed in the United States of America</em></p>
<p class="textcenter">Library of Congress Cataloging-in-Publication Data</p>
<p class="textcenter">King, Lily.<br/>The pleasing hour : a novel / by Lily King.<br/>p.   cm.<br/>eBook ISBN-13: 978-0-8021-9786-3<br/>I. Title.<br/>PS3561.I4814P58 1999<br/>813′.54—dc21       99-25528</p>
<p class="textcenter">Design by Laura Hammond Hough</p>
<p class="textcenter">Grove Press<br/>an imprint of Grove/Atlantic, Inc.<br/>841 Broadway<br/>New York, NY 10003</p>
<p class="textcenter">Distributed by Publishers Group West<br/><span class="weblink"><a class="nounder" href="http://www.groveatlantic.com" target="_blank">www.groveatlantic.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?00d13b56